import ChangePassword from "@/views/auth/ChangePassword";
import CreateInvestorAccountAuth from "@/views/auth/CreateInvestorAccountAuth";
import ForgotPassword from "@/views/auth/ForgotPassword";
import LoginView from "@/views/auth/LoginView";
import Registration from "@/views/auth/Registration";

export default {
  Registration,
  LoginView,
  CreateInvestorAccountAuth,
  ChangePassword,
  ForgotPassword
};
